export default __webpack_public_path__ + "ebdeaf1736e4d28dd82d78f9b71c792b.png";